import architecture from './../assets/architecture.jpg';
import btp from './../assets/btp.jpg';
import bussiness from './../assets/bussiness.jpg';
import comptability from './../assets/comptability.avif';
import develop from './../assets/devolop.jpg';
import financy from './../assets/financy.avif';
import logistic from './../assets/logistic.jpg';
import manage from './../assets/manage.jpg';
import purchase from './../assets/purchase.jpg';
import negoce from './../assets/negoce.jpg';

export const servicesData = [
    {
        id: 0,
        title: "Comptabilité",
        description: "Gestion professionnelle de vos finances, comprenant la tenue de livres, la préparation et l'établissement des états financiers et la gestion des impôts",
        image: comptability,
        servicesFournis: ["Tenue de livres", "Préparation des états financiers", "Gestion des impôts"]
    },
    {
        id: 1,
        title: "Gestion",
        description: "Optimisation et organisation de vos activités commerciales, y compris la gestion des stocks, la planification stratégique et la gestion des ressources humaines",
        image: manage,
        servicesFournis: ["Gestion des stocks", "Planification stratégique", "Gestion des ressources humaines"]
    },
    {
        id: 2,
        title: "Fiscalité",
        description: "Analyse et optimisation des obligations fiscales, préparation des déclarations fiscales et conseil en matière de réglementation fiscale pour assurer une conformité optimale et minimiser les charges fiscales",
        image: financy,
        servicesFournis: ["Analyse des obligations fiscales", "Préparation des déclarations fiscales", "Conseil en réglementation fiscale"]
    },
    {
        id: 3,
        title: "Import-Export",
        description: "Gestion des opérations d'import-export, y compris la documentation douanière, la logistique internationale et la conformité réglementaire, pour faciliter les échanges commerciaux à l'échelle mondiale",
        image: logistic,
        servicesFournis: ["Consultation en commerce international", "Documentation douanière", "Logistique internationale"]
    },
    {
        id: 4,
        title: "Commerce",
        description: "Soutient et à optimisation des activités commerciales, couvrant divers aspects tels que la gestion des stocks, les stratégies de tarification, les relations avec les fournisseurs et la satisfaction client, pour favoriser la croissance et le succès des entreprises",
        image: purchase,
        servicesFournis: ["Gestion des stocks", "Marketing et promotion", "Distribution", "Logistique"]
    },
    {
        id: 5,
        title: "Agro-Bussiness",
        description: "accompagnement dans la gestion des exploitations, la distribution des produits, la réglementation sectorielle et les stratégies de développement durable, pour répondre aux défis spécifiques de ce secteur en constante évolution",
        image: bussiness,
        servicesFournis: ["Consultation en gestion agricole", "Formation et développement professionnel", "Technologie agricole"]
    },
    {
        id: 6,
        title: "Négociation",
        description: " Conseils en négociation commerciale, offrant une expertise dans la gestion des transactions, la résolution des conflits, les accords contractuels et les partenariats stratégiques, pour garantir des résultats efficaces et équitables pour toutes les parties impliquées",
        image: negoce,
        servicesFournis: ["Conseils en négociation commerciale", "Gestion des transactions", "Accords contractuels", "Partenariats stratégiques"]
    },
    {
        id: 7,
        title: "Développement d'applications Web",
        description: "Nous concevons et développons des applications web personnalisées, offrant des solutions novatrices et adaptées à chaque projet, tout en mettant l'accent sur la convivialité, les performances et la sécurité",
        image: develop,
        servicesFournis: ["Conception et développement d'applications web sur mesure", "Développement front-end et back-end", "Maintenance et support", "Tests et assurance qualité"]
    },
    {
        id: 8,
        title: "Architecture",
        description: "Nous offrons des services d'architecture qui intègrent la créativité et l'expertise pour concevoir des espaces uniques et fonctionnels, adaptés aux exigences particulières de chaque projet",
        image: architecture,
        servicesFournis: ["Conception architecturale", "Consultation en conception", "Gestion de projet", "Rénovation et réhabilitation", "Conformité réglementaire"]
    },
    {
        id: 9,
        title: "BTP",
        description: "Fournissement des solutions de construction de qualité, respectant les normes ; tout en respectant les délais impartis et garantissant la satisfaction du client en fournissant des solutions de construction de qualité, avec un accent particulier sur l'efficacité",
        image: btp,
        servicesFournis: ["Construction de bâtiments", "Travaux de génie civil", "Construction écologique et durable", "Services de conseil et d'ingénierie", "Construction écologique et durable"]       
    },
];